<template>
  <div class="file-search">
    <div class="top-breadcrumb">
      <el-breadcrumb separator="/">
        <template v-if="searchType === 'docTrans'">
          <el-breadcrumb-item :to="{ name: 'documentTranslation' }">
            {{$t('fileManage.docTranslation')}}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'translationHistory' }">{{$t('fileManage.transHistory')}}
          </el-breadcrumb-item>
        </template>
        <template v-else>
          <el-breadcrumb-item :to="{ name: 'ProjectList' }">{{$t('projectDetailsV2.itemManage')}}
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'fileManage' }">{{$t('fileManage.fileManage')}}
          </el-breadcrumb-item>
        </template>
        <el-breadcrumb-item>{{$t('fileManage.retrieve')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="search-box">
      <div class="search-box-top">
        <div class="box-top-left">
          <el-input size="small" v-model="query.filter.keyword"
                    :placeholder="$t('retrieval.retrievalTips')">
          </el-input>
          <el-button size="small" type="primary" @click="handleSearch">{{$t('fileManage.retrieve')}}
          </el-button>
        </div>
        <div class="expand-button" @click="handleExpand">{{$t('newProjectV2.advancedSetting')}}<i
             class="el-icon-arrow-down" :class="{ expand: expand }"></i></div>
      </div>
      <div class="search-box-bottom" :class="{ expand: expand }">
        <ul>
          <li>
            <span>{{$t('newProjectV2.langPair')}}</span>
            <el-select clearable size="small" v-model="query.filter.sourceLang"
                       @change="changeSource">
              <el-option v-for="item in filterDate.sourceLangList" :key="item.code"
                         :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]"
                         :value="item.code" :placeholder="$t('jobManagementV2.selectText')">
              </el-option>
            </el-select>
            <i></i>
            <el-select clearable size="small" v-model="query.filter.targetLang"
                       @change="changeTarget">
              <el-option v-for="item in filterDate.targetLangList" :key="item.code"
                         :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]"
                         :value="item.code" :placeholder="$t('jobManagementV2.selectText')">
              </el-option>
            </el-select>
          </li>
          <li>
            <span>{{$t('newProjectV2.domain')}}</span>
            <el-select clearable size="small" v-model="query.filter.domainCode">
              <el-option v-for="item in filterDate.domainNameList" :key="item.domainCode"
                         :label="$i18n.locale === 'zh' ? item.domainName : $domainCase[item.domainCode]"
                         :value="item.domainCode" :placeholder="$t('jobManagementV2.selectText')">
              </el-option>
            </el-select>
          </li>
        </ul>
      </div>
    </div>
    <div class="search-content" :class="{ expand: expand }">
      <div class="search-content-top">
        <!-- <div>共计<span class="num">{{ totalRows }}</span>条结果</div> -->
        <div v-html="$t('retrieval.retrievalCount', [totalRows])"></div>
      </div>
      <div class="search-content-list" ref="searchContentList">
        <ul class="">
          <li class="list-item" v-for="item in fileList" :key="item.id">
            <div class="list-item-name">
              <span class="file-name" @click="handleView(item)"
                    v-html="textKeywordHeightLight(item.name, heightLightKeyword)"></span>
              <div style="display: flex;">
                <el-button size="small" @click="handleView(item)">{{$t('common.view')}}</el-button>
                <el-button v-if="searchType === 'docTrans'" slot="reference" size="small"
                           type="primary" @click="handleDownload(item)">{{$t('common.download')}}
                </el-button>
                <el-popover v-else :offset="20" placement="bottom" trigger="click"
                            popper-class="search-file-download" :ref="`popover-${item.id}`"
                            @after-leave="downloadHide" :visible-arrow='false'>
                  <el-cascader-panel :options="options" :props='props' v-model="downloadStr"
                                     @change='downloadFile($event, item)'></el-cascader-panel>
                  <el-button slot="reference" size="small" type="primary">{{$t('common.download')}}
                  </el-button>
                </el-popover>
              </div>
            </div>
            <div class="list-item-info">
              <span
                    class="lang-pair">{{ $i18n.locale === 'zh' ? item.langDesc.replace('>', ' — ') : $langCase[item.sourceLang] + ' — '+ $langCase[item.targetLang] }}</span>
              <span
                    class="domain">{{ $i18n.locale === 'zh' ? item.domainName : $domainCase[item.domainCode] }}</span>
            </div>
            <!-- <div class="list-item-sent" v-for="i in item.sentList" :key="i.id" v-html="i.sourceSent"></div> -->
            <div v-for="(sent, index) in item.sentList" :key="sent.id"
                 :class="{ 'even-rows': index % 2 === 1 }">
              <div class="list-item-sent" v-if="sent.sourceSent" v-html="sent.sourceSent"></div>
              <div class="list-item-sent" v-if="sent.targetSent" v-html="sent.targetSent"></div>
            </div>
            <div class="list-item-project" v-if="searchType !== 'docTrans'">
              <span>{{$t('task.project')}}：</span>
              <span class="project-name" @click="handlerProjectdetail(item)"
                    v-html="textKeywordHeightLight(item.projectName, heightLightKeyword)"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <async-download-file :isDownloadLoading="isDownloadLoading" :asyncDownloadFun="asyncDownloadFun"
                         @handleClose="handleDownloadClose"></async-download-file>
    <translation-download-dialog :downloadVisible="downloadVisible" :downloadType="'download'"
                                 @handlerClose="closeDownload" :downloadId="downloadId"
                                 :idList="[]"></translation-download-dialog>
  </div>
</template>

<script>
import { filterData, searchFile } from "@/services/fileManage";
import { exportAsyncTransFile, exportTransFileXlf, exportTransFileTmx } from '@/services/projectDetailsApi';

import AsyncDownloadFile from '@/components/async-download-file';
import translationDownloadDialog from '@/views/intelligentTranslation/components/translationDownloadDialog';

export default {
  name: 'FileSearch',
  components: {
    AsyncDownloadFile,
    translationDownloadDialog,
  },
  data () {
    return {
      searchType: '', // docTrans 为文档翻译跳转过来，fileManage为文件管理
      asyncDownloadFun: () => { },
      isDownloadLoading: false, // 文件管理下载
      downloadVisible: false, // 文档翻译下载
      downloadId: null,
      queryData: {},
      paramsData: {},
      expand: false,
      userId: String(JSON.parse(localStorage.userInfo).id),
      query: {
        filter: {
          keyword: '',
          sourceLang: '',
          targetLang: '',
          domainCode: '',
        },
        rows: 20,
        page: 1,
      },
      fileList: [],
      totalRows: 0,
      totalPage: 0,
      filterDate: {
        sourceLangList: [],
        targetLangList: [],
        domainNameList: []
      },
      options: [
        { label: this.$t('projectV2.original'), value: 'original' },
        {
          label: this.$t('projectV2.translate'), value: 'translate', children: [
            { label: this.$t('projectV2.translation'), value: 'translate-translation' },
            { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
          ]
        },
        { label: this.$t('projectV2.revise'), value: 'modify' },
        { label: this.$t('projectV2.archive'), value: 'TMXreport' },
        { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
      ],
      props: {
        expandTrigger: 'hover',
        emitPath: false,
      },
      downloadStr: '',
      heightLightKeyword: '',
      cloneTargetLangList: [],
      cloneSourceLangList: [],
      transModel: null
    };
  },
  created () {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.searchType = this.queryData.searchType;
    if (this.searchType === 'docTrans') {
      this.query.filter.transModel = 2;
      this.transModel = 2
    } else {
      this.query.filter.transModel = 0;
      this.transModel = 0
    }
    if (this.$route.params.key) {
      this.paramsData = JSON.parse(this.$Base64.decode(this.$route.params.key));
      this.query.filter.keyword = this.paramsData.searchKeyword;
      this.query.filter.domainCode = this.paramsData.domainCode;
      this.query.filter.sourceLang = this.paramsData.sourceLang;
      this.query.filter.targetLang = this.paramsData.targetLang;
      this.heightLightKeyword = this.paramsData.searchKeyword;
      this.getFileList();
    }
    // console.log(this.searchType);
    this.getFilterData();
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.searchContentList.addEventListener('scroll', this.handleScrollList);
    });
  },
  methods: {
    handlerProjectdetail (row) {
      this.$router.push({
        name: "ProjectDetail", query: {
          id: row.projectId
        }
      })
    },
    changeSource (value) {
      this.filterDate.targetLangList = this.cloneTargetLangList.filter(item => {
        return item.code !== value;
      })
    },
    changeTarget (value) {
      this.filterDate.sourceLangList = this.cloneSourceLangList.filter(item => {
        return item.code !== value;
      })
    },
    textKeywordHeightLight (value, keyword) {
      if (!value) {
        return "--"
      }
      return value.replace(new RegExp(keyword, 'g'), '<em class="keyword">' + keyword + '</em>');
    },
    handleScrollList (e) {
      const target = e.target
      if (target.clientHeight + target.scrollTop === target.scrollHeight) {
        if (this.query.page < this.totalPage) {
          this.query.page += 1;
          this.getFileList();
        }
      }
    },
    handleDownload (row) {
      this.downloadId = row.id
      this.downloadVisible = true;
    },
    closeDownload () {
      this.downloadId = null;
      this.downloadVisible = false;
    },
    async getFileList () {
      let { success, result } = await searchFile(this.query);
      if (success) {
        let { fileList, totalRows, totalPage } = result;
        this.fileList.push(...fileList);
        this.totalRows = totalRows;
        this.totalPage = totalPage;
      }
    },
    handleSearch () {
      this.query.page = 1;
      this.query.rows = 20;
      this.fileList = [];
      this.heightLightKeyword = this.query.filter.keyword;
      this.getFileList();
    },
    handleExpand () {
      this.expand = !this.expand;
    },
    async getFilterData () {
      const { result, success } = await filterData({
        userId: this.userId,
        transModel: this.transModel
      })
      if (success) {
        Object.keys(result).forEach(item => {
          this.filterDate[item] = result[item];
        })
        this.cloneTargetLangList = result.targetLangList;
        this.cloneSourceLangList = result.sourceLangList;
      }
    },
    handleView (item) {
      // this.$router.push({
      //   name: "filePreview",
      //   query: {
      //     key: this.$Base64.encode(JSON.stringify({
      //       id: item.id,
      //       langDesc: item.langDesc,
      //       name: item.name,
      //       sourceLang: item.sourceLang,
      //       targetLang: item.targetLang,
      //     }))
      //   }
      // })
      if (this.searchType === 'docTrans') {
        if (item.status === 0) {
          this.$message.closeAll();
          this.$message({
            message: item.remark || this.$t('projectDetailsV2.fileParsingFailure'),
            type: "warning",
          });
          return;
        }
        if (item.status > 1) {
          this.$message.closeAll();
          this.$message({
            message: this.$t('projectDetailsV2.fileParsingNotEdit'),
            type: "warning",
          });
          return;
        }
        let userId = JSON.parse(localStorage.getItem("userInfo")).id;
        let obj = {};
        Reflect.set(obj, 'project', (item.finish));
        Reflect.set(obj, 'sourceLang', (item.sourceLang));
        Reflect.set(obj, 'targetLang', (item.targetLang));
        Reflect.set(obj, 'taskName', (item.name));
        Reflect.set(obj, 'userId', (userId || ''));
        Reflect.set(obj, 'wordNum', (item.sourceWordNum));
        Reflect.set(obj, 'transStatus', 2);
        Reflect.set(obj, 'isSplit', item.isSplit);
        Reflect.set(obj, 'langDesc', item.langDesc);
        Reflect.set(obj, 'taskType', 1);
        Reflect.set(obj, 'progress', item.progress);
        Reflect.set(obj, 'fileSuffix', item.fileUsableSuffix);
        Reflect.set(obj, 'transModel', item.transModel);
        Reflect.set(obj, 'taskCount', item.taskCount);
        Reflect.set(obj, 'finish', item.finish);
        sessionStorage.setItem("fileName", item.name)
        //老版参数
        Reflect.set(obj, 'fileId', (item.id));
        Reflect.set(obj, 'type', 'project');
        Reflect.set(obj, 'taskId', null);
        Reflect.set(obj, 'projectId', (item.projectId));
        // 小型编辑器所需要
        if (this.searchType === 'docTrans') {
          Reflect.set(obj, 'routerType', "translationHistory");
        } else {
          Reflect.set(obj, 'routerType', "fileManage");
        }
        Reflect.set(obj, 'routerData', this.queryData);
        let routeData = this.$router.resolve({
          path: "/translationDetail",
          query: {
            key: this.$Base64.encode(
              JSON.stringify(obj)
            )
          }
        });
        window.open(routeData.href, "_self");
        return;
      } else {
        // let routeData = this.$router.resolve({
        //   name: "filePreview",
        //   query: {
        //     key: this.$Base64.encode(JSON.stringify({
        //       id: item.id,
        //       langDesc: item.langDesc,
        //       name: item.name,
        //       sourceLang: item.sourceLang,
        //       targetLang: item.targetLang,
        //     }))
        //   }
        // });
        // window.open(routeData.href, "_blank");
        this.$router.push({
          name: "filePreview",
          query: {
            key: this.$Base64.encode(JSON.stringify({
              id: item.id,
              langDesc: item.langDesc,
              name: item.name,
              sourceLang: item.sourceLang,
              targetLang: item.targetLang,
              // 进入预览需要
              intoType: 'fileSearch',
              routerData: this.query.filter,
            }))
          }
        });
      }
    },
    downloadFile (value, item) {
      let id = item.id;
      let type = null
      this.$refs[`popover-${item.id}`][0].doClose();
      switch (value) {
        case 'original':
          type = 6
          this.onDownload(type, id);
          break;
        case 'translate-translation':
          type = 1
          this.onDownload(type, id);
          break;
        case 'translate-contrast':
          type = 2
          this.onDownload(type, id);
          break;
        case 'modify':
          type = 5
          this.onDownload(type, id);
          break;
        case 'XLFreport':
          this.onDownloadXlf(id);
          break;
        case 'TMXreport':
          this.onDownloadTmx(id);
          break;
      }
    },
    async onDownload (type, id) {
      let param = {
        type,
        fileId: id,
      };
      this.asyncDownloadFun = () => exportAsyncTransFile(param);
      this.isDownloadLoading = true;
    },
    async onDownloadXlf (id) {
      let { resultCode, result } = await exportTransFileXlf({ id });
      if (resultCode === '1') {
        window.open(result);
      }
    },
    async onDownloadTmx (id) {
      let { resultCode, result } = await exportTransFileTmx({ id });
      if (resultCode === '1') {
        window.open(result);
      }
    },
    handleDownloadClose () {
      this.asyncDownloadFun = () => { };
      this.isDownloadLoading = false;
    },
    // 级联隐藏
    downloadHide () {
      this.downloadStr = '';
    },
  },
}
</script>

<style lang="less" scoped>
.file-search {
  line-height: 1.5;
  height: 100%;
  background: #fff;
  padding: 15px;
  box-sizing: border-box;
}
.search-box {
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
  .search-box-top {
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .box-top-left {
      display: flex;
      .el-input {
        width: 533px;
      }
      .el-button {
        margin-left: 10px;
      }
    }
    .expand-button {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #0078fc;
      line-height: 1.5;
      padding: 0 5px;
      i {
        margin-left: 8px;
        transition: 0.3s;
        transform-origin: 50% 50%;

        &.expand {
          transform: rotate(180deg);
        }
      }
    }
  }
  .search-box-bottom {
    height: 0;
    transition: height 0.3s;
    overflow: hidden;
    display: flex;
    &.expand {
      height: 48px;
      box-sizing: border-box;
    }
    ul {
      display: flex;
      padding-top: 15px;
      li {
        height: 32px;
        line-height: 32px;
        display: flex;
        & > span {
          margin-right: 20px;
        }
        & > i {
          width: 50px;
          background: url("./images/icon-lang-btn.png") no-repeat center center;
        }
        .el-select {
          width: 160px;
        }
      }
      li + li {
        margin-left: 40px;
      }
    }
  }
}
.search-content {
  transition: 0.3s;
  height: calc(100% - 14px - 62px);
  &.expand {
    height: calc(100% - 14px - 111px);
  }
  box-sizing: border-box;
  padding: 15px 0 0;
  .search-content-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .num {
      margin: 0 5px;
      color: #ff6969;
    }
  }
  .search-content-list {
    height: calc(100% - 36px);
    overflow-y: auto;
    li + li {
      border-top: 1px solid #ebeef5;
      margin-top: 15px;
      padding-top: 15px;
    }
  }
}
.search-content-list {
  .list-item {
    width: calc(100% - 3px);
  }
  li {
    .list-item-name {
      height: 32px;
      line-height: 32px;
      display: flex;
      justify-content: space-between;
      .file-name {
        color: #2f2f30;
        font-weight: bold;
        cursor: pointer;
        /deep/.keyword {
          color: #ff6969;
        }
      }
      .el-button--default {
        border-color: #0078fc;
        color: #0078fc;
        margin-right: 15px;
      }
    }
    .list-item-info {
      height: 24px;
      line-height: 24px;
      display: flex;
      margin-top: 10px;
      span {
        padding: 0 8px;
        border-radius: 2px;
      }
      span + span {
        margin-left: 8px;
      }
      .lang-pair {
        color: #ffa43b;
        background-color: rgba(255, 164, 59, 0.08);
        border: 1px solid rgba(255, 164, 59, 0.1);
        font-size: 12px;
        line-height: 22px;
      }
      .domain {
        color: #0078fc;
        background-color: rgba(0, 120, 252, 0.08);
        border: 1px solid rgba(0, 120, 252, 0.1);
        font-size: 12px;
        line-height: 22px;
      }
    }
    // .even-rows {
    //   background-color: rgba(0, 120, 252, 0.08);
    // }
    .list-item-sent {
      min-height: 22px;
      line-height: 22px;
      margin-top: 10px;
      text-align: left;
      color: #2f2f30;
      // text-indent: 28px;
      /deep/ span {
        color: #ff6969 !important;
      }
    }
    .list-item-project {
      display: flex;
      margin-top: 10px;
      .project-name {
        color: #0078fc;
        cursor: pointer;
        /deep/.keyword {
          color: #ff6969;
        }
      }
    }
  }
  li + li {
    border-top: 1px solid #ebeef5;
    margin-top: 15px;
    padding-top: 15px;
  }
}
</style>
<style lang="less">
.search-file-download {
  padding: 0;
  transform: translate(-60%, 0);
  .el-cascader-panel {
    .el-cascader-menu {
      min-width: 130px;
      .el-scrollbar__wrap {
        ul {
          li {
            height: 32px;
            .el-icon-check {
              display: none;
            }
            .el-cascader-node__label {
              line-height: 32px;
            }
          }
        }
      }
    }
  }
}
</style>